module.exports = __webpack_public_path__ + "static/media/513.a5f45213.jpg";